module.exports = ".login{\r\n    background-color: white;\r\n\r\n}\r\n.account-form{\r\n    padding-top: 3em;\r\n    float: left;\r\n    width: 100%;\r\n    border-top: solid 1px darkgrey;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main